<template>  
<div>
    <b-container v-if="loading" class="text-center">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
    </b-container>
    <b-container v-if="!loading" class="conta"> 
        <b-row>
            <b-col> 
                <p class="h3">
                    Solicitud de Notificación Electrónica 
                </p> 
            </b-col> 
        </b-row>  
     
        <b-row> 
            <b-col sm="10" xl="8">
                <p>
                    Solicito que las notificaciones asociadas a modificaciones de mi inscripción electoral, sean comunicadas al siguiente e-mail.
                </p>

            </b-col>
        </b-row>
        <div  v-if="!cambiar">
            <b-row>
            <b-col sm="3">Correo actual </b-col>
            <b-col sm="7" xl="5"> 
                <b-form-input
                    disabled  
                    type="email" 
                    autocomplete="nope" 
                    :placeholder="email_actual">
                </b-form-input> 
            </b-col>
        </b-row>
        <b-row  class="mt-3">
                <b-col sm="10" xl="8">
                    <b-button @click="cambiar=true" block variant="primary">Registrar / Cambiar</b-button> 
                </b-col>
            </b-row>
        </div>
        <div v-if="cambiar">
            <b-row  class="mt-3">
                <b-col sm="12" xl="2">
                    <b-button @click="cambiar=false" block variant="danger">Volver</b-button> 
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col sm="3"> E-mail </b-col>
                <b-col sm="7" xl="5"> 
                    <b-form-input
                        :class="{ 'is-invalid': $v.email.$invalid }"  
                        v-model="email" 
                        type="email" 
                        autocomplete="nope" 
                        placeholder="e-mail">
                    </b-form-input>
                    <p v-if="!$v.email.required" class="invalid-feedback mb-0">
                        El email es requerido
                    </p>  
                    <p v-if="!$v.email.email" class="invalid-feedback mb-0">
                        El formato del correo no es correcto
                    </p>  
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col sm="3"> Confirma e-mail</b-col>
                <b-col sm="7" xl="5"> 
                    <b-form-input
                        :class="{ 'is-invalid': $v.email_confirmation.$invalid }"   
                        v-model="email_confirmation" 
                        type="email" 
                        autocomplete="nope" 
                        placeholder="confirma e-mail">
                    </b-form-input> 
                    <p v-if="!$v.email_confirmation.required" class="invalid-feedback mb-0">
                        El confirma e-mail es requerido
                    </p>  
                    <p v-if="!$v.email_confirmation.sameAsEmail" class="invalid-feedback mb-0">
                        Los campos email y confirma email no coincide
                    </p> 
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col sm="10" xl="8">
                    <b-button @click="confirmar" :disabled="$v.$invalid " block variant="primary">Confirmar</b-button> 
                </b-col>
            </b-row>
        </div>

     
       
    </b-container> 
</div> 
</template>  
 
<script>  
 
import { required, email, sameAs } from 'vuelidate/lib/validators'  
import axios from 'axios'  
import Swal from 'sweetalert2'  
import { mapState, mapActions } from "vuex"


 
 

export default {
    name: "ActualizarCorreo",  
    data: function () {
    return { 
            cambiar:false,
            loading : true,
            email_actual: 'No registrado',
            email: '',
            email_confirmation: '' 
        }
    },
    computed: {
        ...mapState(['registro'])
    },
    validations :{ 
        email: { required, email },
        email_confirmation: { required, email, sameAsEmail: sameAs('email') }
    },  
    async mounted()
    {  

        if(!this.registro) return 

        await this.getCorreoActual()

        this.loading = false 
    },
    methods: { 

        async getCorreoActual()
        {
            try{
            const { data: { correo, statusCode} } = await axios.get(`${ process.env.VUE_APP_API_URL }/user/correo`)


            if(statusCode!= 200 ) throw { message: 'Error al intentar obtener el correo actual'}

            if(correo.id) this.email_actual = correo.correo

            }catch(error){
                console.log('Error al obten el correo::', error)
                return Swal.fire({
                    icon: 'error', 
                    text: 'Error al intentar obtener el correo actual',
                    confirmButtonText: 'Aceptar',
                }) 
            }

        },
        async confirmar()
        {
            this.loading = true
            
            try{ 
                const  body = {}
                body.email = this.email
                body.email_confirmation = this.email_confirmation
                body.nombre = this.registro.nombre

                const { data } = await axios.post(`${ process.env.VUE_APP_API_URL }/user/correo`, body)

                if(data.statusCode !=  200 ) throw data

                await this.getCorreoActual()
                this.loading = false 
                this.cambiar = false

             
                return Swal.fire({
                    icon: 'success', 
                    text: 'Correo actualizado de forma correcta',
                    confirmButtonText: 'Aceptar',
                }) 
 
            }catch(error){
                this.loading = false 

                console.log('Error al insertar el correo::', error)

                 return Swal.fire({
                    icon: 'error', 
                    text: 'Error al actualizar el corrreo',
                    confirmButtonText: 'Aceptar',
                }) 
                
            } 
        }
       
    }
}
</script>

<style>
</style>
